import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Pagination from "../../../components/Pagination";
import Table from "../../../components/table";
import usePagination from "../../../components/usePagination";
import BackButton from "../../../components/BackButton";
import api from "../../../api/api";
import * as bootstrap from "bootstrap";
import "../../../pages/Freight/Common/form.css";

const SalesEnquiries = () => {
  const location = useLocation();
  const { enq_ids } = location.state || {};
 
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
 
  /* ================= FETCH ENQUIRIES ================= */
  useEffect(() => {
    if (!enq_ids || enq_ids.length === 0) {
      setError("No enquiry IDs provided");
      setLoading(false);
      return;
    }
 
    const fetchEnquiries = async () => {
      setLoading(true);
      try {
        const customerIds = enq_ids.join(",");
        const response = await api.get("/sales/enquiries", {
          params: { customer_ids: customerIds },
        });
 
        setEnquiries(response.data.enquiries || []);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch enquiries");
      } finally {
        setLoading(false);
      }
    };
 
    fetchEnquiries();
  }, [enq_ids]);
 
  /* ================= PAGINATION ================= */
  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(enquiries, 5);
 
  /* ================= TOOLTIP ================= */
  useEffect(() => {
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach((el) => new bootstrap.Tooltip(el));
  }, [enquiries, currentPage]);
 
  if (error) return <p className="text-danger">{error}</p>;
 
  /* ================= TABLE COLUMNS ================= */
  const columns = [
    {
      label: "Client Name",
      render: (enq) => (
        <span
          data-bs-toggle="tooltip"
          title={`${enq.first_name} ${enq.last_name}`}
        >
          {enq.first_name} {enq.last_name}
        </span>
      ),
    },
    {
      label: "Shipment Segment",
      render: (enq) => (
        <span
          data-bs-toggle="tooltip"
          title={enq.shipment_segment || "N/A"}
        >
          {enq.shipment_segment || "N/A"}
        </span>
      ),
    },
    {
      label: "Trade Segment",
      render: (enq) => (
        <span
          data-bs-toggle="tooltip"
          title={enq.trade_segment || "N/A"}
        >
          {enq.trade_segment || "N/A"}
        </span>
      ),
    },
   {
  label: "Handled By",
  render: (enq) => {
    let name = enq.created_by;

    if (!name) {
      name = "N/A";
    } else {
      // Convert anything to string
      name = String(name).trim();

      // Case 1: comma-separated duplicates
      if (name.includes(",")) {
        const parts = name
          .split(",")
          .map((p) => p.trim())
          .filter(Boolean);

        // If all names are same, keep one
        if (new Set(parts).size === 1) {
          name = parts[0];
        }
      }

      // Case 2: concatenated duplicates (no separator)
      const half = name.length / 2;
      if (
        name.length % 2 === 0 &&
        name.slice(0, half) === name.slice(half)
      ) {
        name = name.slice(0, half);
      }
    }

    return (
      <span data-bs-toggle="tooltip" title={name}>
        {name}
      </span>
    );
  },
},

    // {
    //   label: "Status",
    //   render: (enq) => {
    //     const status =
    //       enq.status === "New"
    //         ? "Follow Up Pending"
    //         : enq.status || "N/A";
 
    //     return (
    //       <span data-bs-toggle="tooltip" title={status}>
    //         {status}
    //       </span>
    //     );
    //   },
    // },

     {
      label: "Follow Up Date",
      render: (enq) => {
        const date = new Date(enq.created_at);
        const dateStr = date.toISOString().split('T')[0];
        const timeStr = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
        return `${dateStr} ${timeStr}`;
      },
    },
    {
      label: "Action",
      render: (enq) => (
        <Link to={`/sales-view-enquiry/${enq.id}?type=followup`}>
          <VisibilityIcon style={{ fontSize: 20 }} />
        </Link>
      ),
    },
  ];
 
  /* ================= RENDER ================= */
  return (
    <>
      <BackButton />
 
      <Table
        columns={columns}
        data={currentItems}
        loading={loading}
        emptyMessage="No Enquiries found."
        itemsPerPage={itemsPerPage}
        pagination={
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
            totalItems={totalItems}
          />
        }
      />
    </>
  );
};
 
export default SalesEnquiries;